import { AuthHttpInterceptor } from "./core/interceptors/authHttp.interceptor";
import {
  BrowserModule,
} from "@angular/platform-browser";
import { NgModule, provideAppInitializer } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { SharedModule } from "./shared/shared.module";
import { SettingsModule } from "./modules";
import { CoreModule } from "../app/core/core.module";
import { AuthGuard } from "../app/core/authentication/authentication.guard";
import { initializeMsal } from "./core/authentication/msal.config";
import { AssetModule } from "./modules/assets/asset.module";
import { ReferencesModule } from "./modules/references/references.module";
import { CustomerModule } from "./modules/customer/customer.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AdminAuthGuard } from "./core/authentication/admin.authentication.guard";
import { ManufacturingAuthGuard } from "./core/authentication/manufacturing.authentication.guard";
import { ReportsModule } from "./modules/reports/reports.module";
import { DashboardModule } from "./modules/dashboard/dashboard.module";
import { AccountModule } from "./modules/account/account.module";
import { LogsModule } from "./modules/logs/logs.module";
import { SearchbarComponent } from "./shared/components/searchbar/searchbar.component";
import { FirmwareModule } from "./modules/firmware/firmware.module";
import { ScoutModule } from "./modules/scouts/scouts.module";
import { SearchBarService } from "./shared/services/searchbar.service";
import { CdkDetailRowDirective } from "./shared/components/roots-table/cdk-detail-row.directive";
import { GroupsModule } from "./modules/groups/groups.module";
import { AvatarComponent } from "./shared/components/avatar/avatar.component";
import { MenuListItemComponent, MenuTopItemComponent, NotFoundComponent, ServerErrorComponent } from "./core";
import { IssuesModule } from "./modules/issues/issues.module";
import { RootsMainMenuButtonComponent } from './shared/components/roots-main-menu-button/roots-main-menu-button.component';
import { NavService } from "./core/components/menu-list-item/nav.service";
import { UtilitiesModule } from "./modules/utilities/utilities.module";
import { AlertsModule } from "./modules/alerts/alerts.module";


@NgModule({
    declarations: [
        AppComponent,
        SearchbarComponent,
        MenuListItemComponent,
        MenuTopItemComponent,
        CdkDetailRowDirective,
        AvatarComponent,
        NotFoundComponent,
        ServerErrorComponent,
        RootsMainMenuButtonComponent
    ],
    imports: [
        BrowserModule,
        CoreModule,
        AppRoutingModule,
        SharedModule,
        SettingsModule,
        UtilitiesModule,
        DashboardModule,
        LogsModule,
        AccountModule,
        FirmwareModule,
        ReportsModule,
        ReferencesModule,
        CustomerModule,
        AssetModule,
        AlertsModule,
        ScoutModule,
        IssuesModule,
        FormsModule,
        ReactiveFormsModule,
        GroupsModule,
        BrowserAnimationsModule
    ],
    providers: [
        AuthGuard,
        AdminAuthGuard,
        ManufacturingAuthGuard,
        SearchBarService,
        provideAppInitializer(initializeMsal),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthHttpInterceptor,
            multi: true,
        },
        NavService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}